import { action, computed, observable } from "mobx";
import { api } from "../../api";
import { ILogSefa, ISolicitacoesSEFA, newILogSefa } from "../../model";
import { toast } from "react-toastify";
import { downloadBinaryFile } from "../../utils";
import { TransmissaoStore } from "../sefip/TransmissaoStore";

export class _SefaStore {
  obs = observable({
    imps: [] as any[],
    historico: [] as any[],
    filter: "" as string,
    currentPage: 1 as number,
    detalhesSolicitacao: false as boolean,
    solicitacao: [] as any[],
    logs_robo: [] as any[],
    erros_sefa: [] as any[],
    open_erros_sefa: false as boolean,
    loadingViewArquivo: false as boolean,
    detalhes_length: 0 as number,
    agendamento_length: 0 as number,
    solicitacoesLength: 0 as number,
    open_view_detalhes: false as boolean,
    view_detalhes: newILogSefa() as ILogSefa,
    log_erros: [] as string[],
    viewArquivos: false as boolean,
    index_agendamentos: [] as any,
    length_agendamentos: 0 as number,
    page_agendamentos: 1 as number,
  })

  @action
  async load(): Promise<void> {
    try {
      let data = { page: 1, limit: 7 };

      let hist = await api.post("/api/solicitacoes-paged", data);

      let l = await api.get(`/api/total-agendados`);

      this.obs.agendamento_length = l.data.total;

      this.obs.historico = [];
      this.obs.historico = hist.data

    } catch (ex) {
      toast.error('Erro ao carregar SEFA, tente novamente mais tarde.', {});
    }
  }

  @action
  async solicitacoesPaged(page: number, limit: number): Promise<void> {
    try {
      let data = { page: page, limit: limit };
      let resp = await api.post("/api/solicitacoes-paged", data);

      this.obs.historico = [];
      this.obs.historico = resp.data

    } catch (ex) {
      toast.error('Erro ao carregar Solicitações SEFA, tente novamente mais tarde.', {});
    }
  }

  @action
  async buscaDetalheSolicitacaoPaged(
    id: any,
    page: number,
    limit: number,
    cnpj: string,
    sefa_new: boolean
  ): Promise<void> {
    try {

      let data = { solicitacao_id: id, page: page, limit: limit, cnpj: cnpj, sefa_new: sefa_new };

      let resp = await api.post(`/api/consulta-status-sefa-solicitacao-id-paged/`, data);
      this.obs.solicitacao = [];

      if (resp.data.solicitacao.length > 0) {
        this.obs.solicitacao = resp.data.solicitacao
        SefaStore.obs.detalhesSolicitacao = true;
      } else {
        toast.warning('Nenhum detalhe para exibir.', {});
      }
    } catch (ex) {
      toast.error('Erro ao consultar status Solicitação SEFA, tente novamente mais tarde.', {});
    }
  }
  @action
  async deletaSolicitacao(id: any): Promise<void> {
    try {
      let resp = await api.delete(`/api/deleta_solicitacao/${id}`);
      this.obs.solicitacao = [];

      if (resp.data.solicitacao.length > 0) {
        this.obs.solicitacao = resp.data.solicitacao
        this.obs.detalhesSolicitacao = true;

      } else {
        toast.warning('Nenhum detalhe para exibir.', {});
      }

    } catch (ex) {
      toast.error('Erro ao deletar Solicitação SEFA, tente novamente mais tarde.', {});
    }
  }
  @action
  async deletaTarefa(id: any): Promise<void> {
    try {
      let resp = await api.delete(`/api/deleta_tarefa/${id}`);
      if (resp.data.ok) {
        this.obs.solicitacao = this.obs.solicitacao.filter(x => { return x.tarefa_id != id });
        this.obs.historico = this.obs.historico?.map(x => { return Object.assign({}, x, { total: x.total - 1 }) })
        this.obs.detalhes_length -= 1;
        toast.success('Deletado com sucesso.', {});
      }
      else {
        toast.warning('Não foi possível completar a operação, tente novamente mais tarde.', {});
      }
    } catch (ex) {
      toast.error('Erro ao deletar Tarefa SEFA, tente novamente mais tarde.', {});
    }
  }

  async setBuscaLimite(
    empresa: any,
    date1: string,
    date2: string,
    page: number,
    limit: number,
    sefa_new: boolean
  ): Promise<void> {

    const data = {
      empresa: empresa,
      data1: date1,
      data2: date2,
      page: page,
      limit: limit,
      sefa_new: sefa_new
    };

    try {
      let resp = await api.post(`/api/busca-solicitacoes-paged`, data);

      if (resp.data == "Conta não Encontrado") {
        alert("Não foram encontrado registros.");

      } else {
        this.obs.imps = [];

        if (resp.data.solicitacoes.length > 0) {
          this.obs.imps = resp.data.solicitacoes

        } else {
          toast.warning('Não foram encontrados resultados.', {});
        }
      }

    } catch (ex) {
      toast.error('Erro ao buscar Solicitações SEFA, tente novamente mais tarde.', {});
    }
  }

  @action
  async setBuscaProgramada(
    empresa: any,
    filtro: string,
    date1: string,
    date2: string,
    sol_id: any,
    sefa_new: boolean,
  ): Promise<void> {

    let params = {
      "empresa": empresa,
      "filtro": filtro,
      "data1": date1,
      "data2": date2,
      "sol_id": sol_id,
      "sefa_new": sefa_new
    }
    try {
      let resp = await api.post(`/api/detalhe-programadas`, params);

      if (resp.data == "Conta não Encontrado") {
        alert("Não foram encontrado registros.");

      } else {
        this.obs.imps = [];

        if (resp.data.solicitacoes.length > 0) {
          this.obs.imps = resp.data.solicitacoes
        } else {
          toast.warning('Não foram encontrados resultados.', {});
        }

      }
    } catch (ex) {
      toast.error('Erro ao carregar Solicitação Programada SEFA, tente novamente mais tarde.', {});
    }
  }

  async length_arquivos(cnpj: string, date1: string, date2: string, sefa_new: boolean) {
    try {
      let req = { empresa: cnpj, date1: date1, date2: date2, sefa_new: sefa_new };

      let resp = await api.post(`/api/total-solicitacoes`, req);

      this.obs.solicitacoesLength = 0;
      this.obs.solicitacoesLength = resp.data.total;
    } catch (ex) {
      toast.error('Erro ao consultar total Solicitações SEFA, tente novamente mais tarde.', {});
    }
  }

  @action
  async length_detalhe(id: string, sefa_new: boolean): Promise<void> {
    try {

      let req = { id: id, sefa_new: sefa_new };

      let resp = await api.post(`/api/total-tarefas`, req);

      this.obs.detalhes_length = resp.data.total;
    } catch (ex) {
      toast.error('Erro ao consultar total Tarefas SEFA, tente novamente mais tarde.', {});
    }
  }
  @action
  async length_agendamento(): Promise<void> {
    try {
      let resp = await api.get(`/api/total-agendados`);

      this.obs.agendamento_length = resp.data.total;
    } catch (ex) {
      toast.error('Erro ao consultar total Agendamentos SEFA, tente novamente mais tarde.', {});
    }
  }

  @action
  setCurrentPage(page: number) {
    this.obs.currentPage = page;
  }

  @action
  setFilter(filter: string) {
    this.obs.filter = filter;
  }

  @computed
  get filtered(): ISolicitacoesSEFA[] {
    let ret = [];
    for (let imp of this.obs.imps.values()) {
      let passesFilter = true;
      let filter = this.obs.filter.toUpperCase();

      if (filter) {
        passesFilter = imp.id != -1 ||
          imp.id != -1 ||
          imp.id != -1;
      }

      if (passesFilter) ret.push(imp);
    }
    return ret;
  }

  getPage(page: number, pageSize = 10000): ISolicitacoesSEFA[] {
    let start = (page - 1) * pageSize;
    let end = start + pageSize;
    return this.filtered.slice(start, end);
  }

  getAllPages(page: number, pageSize = 10000): ISolicitacoesSEFA[] {
    let start = (page - 1) * pageSize;
    let end = start + pageSize;
    return this.filtered.slice(start, end);
  }

  @action
  async buscaLogsBotSEFA(id_solicitacao: string, sefa_new: boolean): Promise<void> {
    try {
      let resp = await api.post(`/api/sefa-get-errors`, { id: id_solicitacao, sefa_new: sefa_new });

      this.obs.logs_robo = [];

      if (resp.data.length > 0) {
        this.obs.logs_robo = resp.data
      } else {
        toast.warning('Nenhum detalhe para exibir.', {});
      }
    } catch (ex) {
      toast.error('Erro ao carregar Logs Bot Erros SEFA, tente novamente mais tarde.', {});
    }
  }

  async handleProgramarAgendamento(params: any) {
    try {

      let resp = await api.post(`/api/sefa/agendamento/create`, params);

      if (resp.data.ok) {
        toast.success('Agendamento criado com sucesso.', {});
        this.handleIndexAgendamentos(1)
      } else {
        toast.error('Erro ao criar agendamento, tente novamente mais tarde.', {});
      }
    } catch (ex) {

      toast.error('Erro ao criar agendamento, tente novamente mais tarde.', {});

    }
  }

  async handleUpdateAgendamento(params: any) {
    try {

      let resp = await api.post(`/api/sefa/agendamento/update`, params);

      if (resp.data.ok) {
        toast.success('Agendamento atualizado com sucesso.', {});
        this.handleIndexAgendamentos(1)
      } else {
        toast.error('Erro ao atualizar agendamento, tente novamente mais tarde.', {});
      }
    } catch (ex) {

      toast.error('Erro ao atualizar agendamento, tente novamente mais tarde.', {});

    }
  }

  async handleIndexAgendamentos(page: number) {

    let params = {
      page: page,
      limit: 5
    }

    let resp = await api.post(`/api/sefa/agendamento/index`, params);

    this.obs.index_agendamentos = []
    this.obs.length_agendamentos = 0

    if (resp.data.itens.length > 0) {

      this.obs.index_agendamentos = resp.data.itens

      this.obs.length_agendamentos = resp.data.count

    }
  }

  async handleDeleteAgendamento(id: string) {
    try {

      let resp = await api.delete(`/api/sefa/agendamento/${id}`);

      if (resp.data.ok) {

        toast.success('Agendamento deletado com sucesso.', {});
        this.handleIndexAgendamentos(1)

      } else {

        toast.error('Erro ao deletar agendamento, tente novamente mais tarde.', {});

      }

    } catch (ex) {

      toast.error('Erro ao deletar agendamento, tente novamente mais tarde.', {});

    }
  }

  async downloadArquivoSefa(nome: string, id: number) {

    try {

      TransmissaoStore.obs.loadingArquivo = true;

      let resp = await api.get(`/api/sefa/download/${id}`, { responseType: 'blob' });

      downloadBinaryFile(resp.data, `${nome}`)

      TransmissaoStore.obs.loadingArquivo = false;

    } catch (ex) {

      TransmissaoStore.obs.loadingArquivo = false;

      toast.error('Erro ao realizar download Transmissão, tente novamente mais tarde.', {});
    }

  }

  async download_sefa_zip(nome: string, files: any) {

    try {

      let req = { nome: nome, files: files }

      TransmissaoStore.obs.loadingArquivoAll = true;

      let resp = await api.post(`/api/sefa/download/zip`, req, { responseType: 'blob' });

      downloadBinaryFile(resp.data, `${nome}.zip`)

      TransmissaoStore.obs.loadingArquivoAll = false;

    } catch (ex) {

      TransmissaoStore.obs.loadingArquivoAll = false;

      toast.error('Erro ao realizar download Transmissão, tente novamente mais tarde.', {});
    }

  }

  async downloadImagemError(id: string) {

    try {

      let data = { filename: id }

      let resp = await api.post("/api/sefa/download/img", data);

      if(resp.data.ok){

        let linkSource = `data:application/png;base64,${resp.data.base64}`
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = `${id}.png`;
        downloadLink.click();

      } else {

        toast.error(resp.data.msg	, {});

      }

    } catch (ex) {

      toast.error('Erro ao realizar download da imagem, tente novamente mais tarde.', {});

    }

  }

  async viewImagemError(id: string) {

    try {

      let data = { filename: id }

      let resp = await api.post("/api/sefa/download/img", data);

      if(resp.data.ok){

        return `data:application/png;base64,${resp.data.base64}`

      }

    } catch (ex) {

      toast.error('Erro ao realizar download imagem, tente novamente mais tarde.', {});

    }

    return null

  }

  async handleProgramar(payload: any) {

    const resp = await api.post(`/api/sefa`, payload);

    return resp.data

  }

}

export const SefaStore = new _SefaStore();
